import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
export class AbstractPauseAdUtilities extends AbstractTagClass {
    #type;
    impression;
    constructor(argument) {
        super(argument);
        this.#type = argument.type;
    }
    get type() {
        return this.#type;
    }
    makePauseAdCall = () => {
        const url = this.getAdCallURL();
        this?.logger?.log('makePauseAdCall:', 'pause ad call url:', url);
        return new Promise((resolve, reject) => {
            if (this.utils.Type.isEmpty(url) === false) {
                if (!window?.fetch) {
                    reject({
                        msg: `makePauseAdCall: fetch API not found: ${window?.fetch}`,
                        success: false
                    });
                }
                window.fetch(url)
                    .then((response) => {
                    this?.logger?.log('makePauseAdCall: raw response:', response);
                    return response.text();
                })
                    .then((text) => {
                    this?.logger?.log('makePauseAdCall: response string:', text);
                    text = this.cleanUpTextResponse(text);
                    return new DOMParser().parseFromString(text, 'text/xml');
                })
                    .then((xml) => {
                    this?.logger?.log('makePauseAdCall: clean xml:', xml);
                    this.impression = this.getImpressions(xml);
                    this?.logger?.log('makePauseAdCall: impression URLs:', this.impression);
                    switch (xml.querySelector('parsererror')) {
                        case null:
                            this?.logger?.log('makePauseAdCall Success: payload:', xml);
                            resolve({
                                msg: `makePauseAdCall Success: payload: ${xml}`,
                                success: true,
                                pauseAd: this.processResponse(xml)
                            });
                            break;
                        default:
                            this?.logger?.warn('makePauseAdCall: xml parser ERROR:', xml);
                            reject({
                                msg: `makePauseAdCall: xml parser ERROR: ${xml}`,
                                success: false
                            });
                    }
                })
                    .catch((error) => {
                    this?.logger?.warn('makePauseAdCall: ERROR:', error, 'Load default pause ad slate instead.');
                    reject({
                        msg: `makePauseAdCall: ERROR: ${error}`,
                        success: false
                    });
                });
            }
            else {
                this?.logger?.warn(`makePauseAdCall: fetch URL is invalid or empty: ${url}`, 'Load default pause ad slate instead.');
                reject({
                    msg: `makePauseAdCall: fetch URL is invalid or empty: ${url}`,
                    success: false
                });
            }
        });
    };
    cleanUpTextResponse = (xmlString) => {
        xmlString = this.utils.String.cleanUp(xmlString);
        xmlString = xmlString.replace(/<Impression><!\[CDATA\[]><\/Impression>/g, '');
        xmlString = xmlString.replace(/&(?!amp;)/g, '&amp;');
        return xmlString;
    };
    getImpressions = (xml) => {
        const impressionURLs = new Array();
        if (this.utils.Type.isXML(xml) === true) {
            const impressionNodes = xml.querySelectorAll('Impression');
            impressionNodes.forEach((node) => {
                const content = (node?.firstChild?.textContent) ? node.firstChild.textContent.trim() : '';
                if (!this.utils.Type.isEmpty(content))
                    impressionURLs.push(content);
            });
        }
        return impressionURLs;
    };
}
